import { render } from "./FooterView.vue?vue&type=template&id=61ecb34c&scoped=true"
import script from "./FooterView.vue?vue&type=script&lang=js"
export * from "./FooterView.vue?vue&type=script&lang=js"

import "./FooterView.vue?vue&type=style&index=0&id=61ecb34c&scoped=true&lang=css"

import exportComponent from "/Users/nick/Desktop/self-gens/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61ecb34c"]])

export default __exports__